export function redirectCompare(baseUrl: string): void {
	setTimeout(function () {
		window.open(baseUrl + 'compare', "_self");
	}, 100);
}